import { ExportButton } from '@/common/buttons/ExportButton';
import { TitleButton } from '@/common/buttons/TitleButton';
import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

/**
 * Per requirement GP-14, this provides a list of transactions used in an Aggregate result with validation errors
 */
export const CalcTrxValViewer = () => {

  const { navState, navigateTo } = useNavState();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const [incDataSrc, setIncDataSrc] = useState();

  const [title, setTitle] = useState();
  const gridRef = useRef();

  const [fieldDefs, setFieldDefs] = useState();
  const [exportReq, setExportReq] = useState();

  useEffect(() => {
    const viewerReqParam = navState.viewerReqParam;
    rsrc.viewerFieldDefs(module, 'CALC_TRX_VAL_VIEWER_PLUGIN', viewerReqParam, navState.entity).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    })

    rsrc.rows('gp', 'INC_DATA_SRC', { expr: ExprUtils.whereParams('id', viewerReqParam.data.incDataSrcId) }).then((dataSrc) => {
      setTitle('Trx Validations for NDC: ' + viewerReqParam.ndc11 + ', Inclusion Data Source: ' + dataSrc[0].name);
      setIncDataSrc(dataSrc[0]);
    })
  }, [])

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {
        const filter = {
          filterType: 'set',
          values: ['Y']
        }


        const filterModel = {};
        filterModel[`_${incDataSrc.code.toLowerCase()}`] = filter;

        const trxSelPeriod = navState.viewerReqParam.data.trxSelPeriod;
        if (trxSelPeriod) {
          filterModel[`_${trxSelPeriod.toLowerCase()}`] = filter;
        }

        const expr = ExprUtils.filterModelToExpr(filterModel, fieldDefs);

        const reqParam = {
          ...navState.viewerReqParam,
          startRow: params.startRow,
          endRow: params.endRow,
          expr
        };
                
        const plugin = 'CALC_TRX_VAL_VIEWER_PLUGIN';
        buildAndSetExportReq(reqParam, plugin);

        rsrc.viewerRows(module, 'CALC_TRX_VAL_VIEWER_PLUGIN', reqParam, navState.entity).then(res => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        })

        rsrc.viewerCount(module, 'CALC_TRX_VAL_VIEWER_PLUGIN', reqParam, navState.entity).then(count => {
          gridRef.current.setCount(count);
        })

        rsrc.viewerAggTotals(module, 'CALC_TRX_VAL_VIEWER_PLUGIN', reqParam, navState.entity).then(aggTotals => {
          gridRef.current.setTotalsRow(aggTotals);
        })
      }
    }

    gridRef.current.setDataSource(dataSource);
  }

  const buildAndSetExportReq = (reqParam, plugin) => {
    const exportReq = {
      timeZoneName: DateUtils.timeZoneName(),
      name: navState.title + ' Export',
      module,
      entity: 'CALC_TRX_VAL',
      uiType: 'VIEWER',
      viewerPluginCode: 'CALC_TRX_VAL_VIEWER_PLUGIN',
      viewerReqParam: reqParam,
      fieldDefs,
    };

    setExportReq(exportReq);
  }
  
  return (
    fieldDefs &&
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Title icon={fas.faListUl} title={title} />
        <Box>
          <TitleButton
            dataTestId={'calc-nav-to-rules'}
            icon={fas.faFilter}
            toolTip="Navigate To Rules"
            onClick={() => navigateTo('gp/inc-rule', { incDataSrcId: navState.viewerReqParam.data.incDataSrcId })}
          />
           <ExportButton exportReq={exportReq} />
        </Box>
      </Box>
      <Grid
        ref={gridRef}
        gridOptions={{ fieldDefs }}
        events={{ onGridReady }}

      />
    </>
  );
}